import React, {useState, useEffect} from 'react';
import CheckinInfoGraphView from './CheckinInfoGraphView';
import {getTaches} from '../../../services/MadricService';

/**
 * La vue pour le graphique
 * @param {*} props props
 * @return {JSX}
 */
export default function CheckinInfoGraph(props) {
  // Liste de taches pour le graphique
  const [listTache, setListTache] = useState([]);

  useEffect(() => {
    props.setTaches(props.startend.taches);
    fetchTaches();
  }, []);

  /**
  * Permet de modifier le graphique
  * @param {*} data data
  * @param {*} ref ref
  */
  function onHandleChange(data, ref) {
    if (ref !== 0) {
      const total = data.reduce((accumulator, {value}) => accumulator + value, 0);
      const minutesPerHour = 60;
      const percentFactor = ref / total;

      data.forEach((d) => {
        const minutesTotal = Math.round(d.value * percentFactor);
        const heures = Math.floor(minutesTotal / minutesPerHour);
        const minutes = minutesTotal % minutesPerHour;
        const minutesFormatted = minutes.toString().padStart(2, '0');
        d.minutes = minutesTotal;
        d.label2 = d.label + ' ' + (heures === 0 ? minutesFormatted + 'min' : heures + 'h' + minutesFormatted);
      });
    }

    props.setTaches([...data]);
  };

  /**
   * Permet d'allez chercher la liste des tâches
   */
  async function fetchTaches() {
    const res = await getTaches();
    // supprime toutes les valeur en double

    setListTache(res);
  }

  // Change les tache a etre display dans le graphique lorsqu'une nouvelle taches est selectionné dans le select
  const handleCheckboxChange = (event) => {
    const selectedIndex = parseInt(event.target.value);
    const isChecked = event.target.checked;

    if (isChecked) {
      props.setTaches((prevSelectedOptions) => {
        const updatedOptions = [
          ...prevSelectedOptions,
          listTache[selectedIndex],
        ];
        return calculateTaskDetails(updatedOptions);
      });
    } else {
      props.setTaches((prevSelectedOptions) => {
        const updatedOptions = prevSelectedOptions.filter(
            (value) => value.label !== listTache[selectedIndex].label,
        );
        return calculateTaskDetails(updatedOptions);
      });
    }
  };


  const calculateTaskDetails = (options) => {
    const total = options.length > 0 ?
  options.reduce((accumulator, {value}) => accumulator + value, 0) :
  0;

    options.forEach((d) => {
      const percent = Math.round(d.value) / Math.round(total);
      const minutesTotal = Math.round(percent * props.nbHeures);
      const heures = Math.floor((percent * props.nbHeures) / 60);
      const minutes = minutesTotal % 60;
      const minutesFormatted = minutes.toString().padStart(2, '0');
      d['minutes'] = minutesTotal;
      d['label2'] = d.label + ' ' + (heures === 0 ? minutesFormatted + 'min' : heures + 'h' + minutesFormatted);
    });

    return options;
  };

  return (
    <div>
      <div className="field">
        <ul className="checkboxes">
          {listTache.map((item, i) => (
            <li className="checkbox" key={i}>
              <input
                className="checkbox-input"
                type="checkbox"
                name="choice"
                value={i}
                id={`choice-${i}`}
                onChange={handleCheckboxChange}
                defaultChecked={props.taches.some((t) => t.label === item.label)} />
              <label
                className="checkbox-label"
                htmlFor={`choice-${i}`}
                style={{backgroundColor: item.color}}>
                {item.label}
              </label>
            </li>
          ))}
        </ul>
        <CheckinInfoGraphView data={props.taches} onHandleChange={onHandleChange} nbHeures={props.nbHeures} />
      </div>
    </div>
  );
}
